module.exports = __webpack_public_path__ + "static/media/fixed-voice-plus.c7da0dc0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed-voice-plus.svg
// module id = 989
// module chunks = 0